import React from 'react'

import Page from '../../../../components/pdf/Page'

import Header from './Header'
import Content from './Content'

const WorkReport = () => {
  return (
    <Page>
      <Header />
      <Content />
    </Page>
  )
}

export default WorkReport
